import { BACKEND_URL } from "../url/Url";

const RESERVATION_BASE = `${BACKEND_URL}/gestion-salle-reunion/`;

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const ReservationSalleService = {
  all: async () => {
    try {
      const response = await fetch(`${RESERVATION_BASE}detail-reservations/`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des réservations:', error);
      return { success: false, error: error.message };
    }
  },

  dateHeure: async () => {
    try {
      const response = await fetch(`${RESERVATION_BASE}date-heure-actuelle`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  date_expire: async (id) => {
    try {
      const response = await fetch(`${RESERVATION_BASE}date-expire/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la suppression automatique:', error);
      return { success: false, error: error.message };
    }
  },

  add: async (reservationData) => {
    try {
      const response = await fetch(`${RESERVATION_BASE}reservation/ajout/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(reservationData)
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout:', error);
      return { success: false, error: error.message };
    }
  },

  update: async (id_reservation, reservationData) => {
    try {
      const userId = parseInt(localStorage.getItem('userId'));
      const payload = {
        data: reservationData,
        user_id: userId
      };
      console.log("Payload:", payload);
  
      const response = await fetch(`${RESERVATION_BASE}reservation/modification/${id_reservation}/`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload)
      });
      
      console.log("Response:", response);
  
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
      return { success: false, error: error.message };
    }
  },
  
  delete: async (id_reservation, user_id) => {
    try {
      const response = await fetch(`${RESERVATION_BASE}reservation/suppression/${id_reservation}/${localStorage.getItem('accessToken')}/`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      return { success: false, error: error.message };
    }
  },

  getById: async (id_reservation) => {
    try {
      const response = await fetch(`${RESERVATION_BASE}reservation/${id_reservation}/`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération:', error);
      return { success: false, error: error.message };
    }
  }
};

export default ReservationSalleService;
